import { toNumberSafe } from '../utilities/NumberHelpers';
import {
    addClientTimesheetContractPhaseAdjustmentSafe,
    createTimesheetDetailContractPhaseAdjustment,
} from './CrewTimesheet';
import _ from 'lodash-es';

export function getTreatAsRemoved(timesheetDetail) {
    if (!timesheetDetail) {
        return false;
    }

    if (timesheetDetail.adjustedRemoved) {
        return true;
    }

    return timesheetDetail.removed && timesheetDetail.adjustedRemoved !== false;
}

const updateTimesheetContractPhaseAdjustmentTimeSpent = (
    timesheet,
    contractPhaseId
) => {
    const timesheetContractPhaseAdjustment =
        timesheet.timesheetContractPhaseAdjustments.find(
            (tcpa) => tcpa.contractPhaseId == contractPhaseId
        );

    const timesheetDetailContractPhases = timesheet.timesheetDetails
        .flatMap((td) => td.timesheetDetailContractPhases)
        .filter((tdcp) => tdcp.contractPhaseId == contractPhaseId);

    const timesheetDetailContractPhaseAdjustments = timesheet.timesheetDetails
        .flatMap((td) => td.timesheetDetailContractPhaseAdjustments)
        .filter((tdcpa) => tdcpa.contractPhaseId == contractPhaseId);

    const hoursWorked =
        _.sumBy(
            timesheetDetailContractPhases.filter(
                (tdcp) =>
                    !tdcp.clientAdjustment &&
                    !tdcp.timesheetDetailContractPhaseAdjustmentId
            ),
            (tdcp) => toNumberSafe(tdcp.quantity)
        ) +
        _.sumBy(timesheetDetailContractPhaseAdjustments, (tdcp) =>
            toNumberSafe(tdcp.quantity)
        );

    timesheetContractPhaseAdjustment.timeSpent = hoursWorked;
};

/**
 * Creates a timesheet detail contract phase adjustment.
 * Will not process if the detail should be treated as removed.
 * @param {*} timesheet
 * @param {*} job
 * @param {*} contractPhaseId
 * @param {*} timesheetDetailId
 * @param {*} quantity
 * @returns
 */
export const onAdminQuantityChange = (
    timesheet,
    job,
    contractPhaseId,
    timesheetDetailId,
    quantity
) => {
    const timesheetDetail = timesheet.timesheetDetails.find(
        (td) => td.id == timesheetDetailId
    );

    if (
        !job ||
        quantity == null ||
        quantity == undefined ||
        !timesheetDetailId ||
        !timesheetDetail
    ) {
        console.error({
            timesheet,
            job,
            contractPhaseId,
            timesheetDetailId,
            quantity,
        });
        throw new Error('Double-check invocation params.');
    }

    if (getTreatAsRemoved(timesheetDetail)) {
        return;
    }

    let timesheetDetailContractPhaseAdjustment =
        timesheetDetail.timesheetDetailContractPhaseAdjustments.find(
            (tdcpa) => tdcpa.contractPhaseId == contractPhaseId
        );

    createTimesheetDetailContractPhaseAdjustment(
        timesheet,
        timesheetDetailId,
        contractPhaseId,
        quantity
    );

    addClientTimesheetContractPhaseAdjustmentSafe(
        timesheet,
        job,
        contractPhaseId
    );

    timesheetDetailContractPhaseAdjustment =
        timesheetDetail.timesheetDetailContractPhaseAdjustments.find(
            (tdcpa) => tdcpa.contractPhaseId == contractPhaseId
        );

    timesheetDetailContractPhaseAdjustment.quantity = quantity;

    updateTimesheetContractPhaseAdjustmentTimeSpent(timesheet, contractPhaseId);
};

/**
 * Creates a timesheet detail contract phase entry.
 * Will not process if the detail should be treated as removed.
 * @param {*} timesheet
 * @param {*} contractPhaseId
 * @param {*} timesheetDetailId
 * @param {*} quantity
 * @returns
 */
export const onFieldUserQuantityChange = (
    timesheet,
    contractPhaseId,
    timesheetDetailId,
    quantity
) => {
    const timesheetDetail = timesheet.timesheetDetails.find(
        (td) => td.id == timesheetDetailId
    );

    if (getTreatAsRemoved(timesheetDetail)) {
        return;
    }

    const timesheetDetailContractPhase =
        timesheetDetail.timesheetDetailContractPhases.find(
            (tdcp) => tdcp.contractPhaseId == contractPhaseId
        );

    timesheetDetailContractPhase.quantity = quantity ?? 0;

    const timesheetContractPhase = timesheet.timesheetContractPhases.find(
        (tcp) => tcp.contractPhaseId == contractPhaseId
    );

    const associatedDetailContractPhases = timesheet.timesheetDetails
        .flatMap((td) => td.timesheetDetailContractPhases)
        .filter((tdcp) => tdcp.contractPhaseId == contractPhaseId);

    timesheetContractPhase.timeSpent = _.sumBy(
        associatedDetailContractPhases,
        (tdcp) => toNumberSafe(tdcp.quantity)
    );
};

